// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tooltip-wrapper {
  display: inline-block;
  position: relative;
}

.tooltip-portal {
  background-color: var(--tooltip-background-color);
  color: var(--tooltip-color);

  padding: 8px;
  border-radius: 4px;
  font-size: 12px;
  white-space: nowrap;

  z-index: 999999;
  pointer-events: none;

  opacity: 1;
}`, "",{"version":3,"sources":["webpack://./src/components/bases/tooltips/tooltip.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,iDAAiD;EACjD,2BAA2B;;EAE3B,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,mBAAmB;;EAEnB,eAAe;EACf,oBAAoB;;EAEpB,UAAU;AACZ","sourcesContent":[".tooltip-wrapper {\n  display: inline-block;\n  position: relative;\n}\n\n.tooltip-portal {\n  background-color: var(--tooltip-background-color);\n  color: var(--tooltip-color);\n\n  padding: 8px;\n  border-radius: 4px;\n  font-size: 12px;\n  white-space: nowrap;\n\n  z-index: 999999;\n  pointer-events: none;\n\n  opacity: 1;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
